import { unwrapResult, } from '@reduxjs/toolkit';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
export const useContentfulDispatch = () => useDispatch();
export const useContentfulSelector = useSelector;
export const useContentfulUnwrap = () => {
    const dispatch = useDispatch();
    return useCallback((asyncThunk) => dispatch(asyncThunk).then(unwrapResult), [dispatch]);
};
